import { put, takeLatest, call } from "redux-saga/effects";
import { message } from "antd";
import api from "service/apiService";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiResponse } from "types";
import {
	GetListSubscriptionTransactionPayload,
	getListSubscriptionTransactionAsync,
	setSubscriptionTransactionList,
	GetSubscriptionTransactionDetailPayload,
	getSubscriptionTransactionDetailAsync,
	setSubscriptionTransactionDetail,
	UpdateSubscriptionTransactionPayload,
	updateSubscriptionTransactionAsync,
} from "./subscription-transaction.slice";
import { t } from "@lingui/macro";

function* getListSubscriptionTransactionSaga(
	action: PayloadAction<GetListSubscriptionTransactionPayload>,
) {
	const { query, callback } = action.payload;
	const skip = query.skip * (query.take || 0);

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<any[]>>(
				"/dashboard/subscription-transactions",
				{
					...query,
					skip,
				},
			);
			!!callback && callback({ success: true });
			return { response };
		} catch (error) {
			!!callback && callback({ success: false });
			return { error };
		}
	});
	if (response) {
		yield put({ type: setSubscriptionTransactionList.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetListSubscriptionTransaction() {
	yield takeLatest(
		getListSubscriptionTransactionAsync,
		getListSubscriptionTransactionSaga,
	);
}

function* getSubscriptionTransactionDetailSaga(
	action: PayloadAction<GetSubscriptionTransactionDetailPayload>,
) {
	const { id, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<any[]>>(
				`/dashboard/subscription-transactions/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({
			type: setSubscriptionTransactionDetail.type,
			payload: response,
		});
		!!callback && callback({ success: true });
	} else {
		message.error(translate(error.message));
		!!callback && callback({ success: false });
	}
}
function* watchGetSubscriptionTransactionDetail() {
	yield takeLatest(
		getSubscriptionTransactionDetailAsync,
		getSubscriptionTransactionDetailSaga,
	);
}

function* updateSubscriptionTransactionSaga(
	action: PayloadAction<UpdateSubscriptionTransactionPayload>,
) {
	const { id, data, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch<ApiResponse<any[]>>(
				"/dashboard/subscription-transactions/" + id,
				data,
			);
			!!callback && callback({ success: true });
			return { response };
		} catch (error) {
			!!callback && callback({ success: false });
			return { error };
		}
	});
	if (response) {
		yield put({
			type: getSubscriptionTransactionDetailAsync.type,
			payload: { id },
		});
		message.success(t`Update successful`);
	} else {
		message.error(translate(error.message));
	}
}
function* watchUpdateSubscriptionTransaction() {
	yield takeLatest(
		updateSubscriptionTransactionAsync,
		updateSubscriptionTransactionSaga,
	);
}

const subscriptionSaga = [
	watchGetListSubscriptionTransaction(),
	watchGetSubscriptionTransactionDetail(),
	watchUpdateSubscriptionTransaction(),
];

export default subscriptionSaga;
